module.exports = __webpack_public_path__ + "mp3/If_I_Had_a_Chicken.mp3";